// Login Batch 2 — the dedicated employee login subdomain.
// isLoginHost() is true ONLY when the app is served from login.credlocity.com, so every host-based
// behavior below is a strict no-op on www.credlocity.com (and before DNS exists).
export const LOGIN_HOST = 'login.credlocity.com';

export function isLoginHost() {
  if (typeof window === 'undefined' || !window.location) return false;
  return (window.location.hostname || '').toLowerCase() === LOGIN_HOST;
}
